<template>
  <div class="admin-template">
    <div class="container-fluid container-top-bar">
      <div class="row">
        <div class="col-lg-12 top-bar-client d-flex justify-content-end">
          <div class="user-logged">
            <span class="red_primary_text">
              Olá,
              <b>{{getFirstNameUser()}}</b>
            </span>
            <div class="logout">
              <span class="red_primary_text" v-on:click="logout()">Sair</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-2 col-12 logo-col d-flex align-items-center justify-content-end">
          <span>Painel administrador</span>
        </div>
        <div class="col-lg-10 col-12 menu-bar d-flex align-items-center">
          <menu-item-component v-for="(item, index) in menuList" :item="item" v-bind:key="index"></menu-item-component>
        </div>
      </div>
    </div>
    <main>
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import MenuItemComponent from "@/components/menu/MenuItemComponent";
import admin from "@/imports/AdminMenuLists/admin";
import webmaster from "@/imports/AdminMenuLists/webmaster";
import writer from "@/imports/AdminMenuLists/writer";
import manager from "@/imports/AdminMenuLists/manager";
import auth from "@/api/auth";
import Loading from "vue-loading-overlay";
import { bus } from "@/main";

export default {
  name: "admin-template",
  components: {
    MenuItemComponent,
    Loading
  },
  data() {
    return {
      loggedClient: false,
      isLoading: false,
      fullPage: true,
      loggedAdmin: false,
      menuList: []
    };
  },
  mounted() {
    let role = localStorage.getItem("auth.user_role");
    this.menuList = this.getMenuListItems(role);
  },
  methods: {
    getFirstNameUser() {
      if (localStorage.getItem("auth.user_name")) {
        let name = localStorage.getItem("auth.user_name");
        return name.split(" ")[0];
      }
      return "";
    },
    logout() {
      bus.$emit("changeLoading", true);
      auth
        .logout()
        .then(data => {
          bus.$emit("changeLoading", false);
          location.reload();
        })
        .catch(error => {
          bus.$emit("changeLoading", false);
        });
    },
    getMenuListItems: function(role) {
      switch (role) {
        case "admin":
          return admin.list;
        case "webmaster":
          return webmaster.list;
        case "writer":
          return writer.list;
        case "manager":
          return manager.list;
        default:
          return [];
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/admin/AdminLayout.scss";
</style>
